import { useEffect, useState } from "react"
import { AvField } from "availity-reactstrap-validation"
import { Row, Col, Card, CardBody, Alert } from "reactstrap"
import { Link } from "react-router-dom"
import ViewAttachments from "components/Application/ViewAttachments"

const BASE_URL = process.env.REACT_APP_BASE_URL

const HeadFormNoObjection = props => {
  const [comments, setcomments] = useState()
  const [showComments, setshowComments] = useState()
  const [showApprovalDuration, setshowApprovalDuration] = useState(false)
  const [showCertificatePreview, setshowCertificatePreview] = useState(false)
  const [staffUploads, setstaffUploads] = useState([])

  const certPreviewUrl =
    BASE_URL + "verify/certificate/" + props.appDetails.app_id + "?preview=true"

  useEffect(() => {
    if (props.appDetails.service_id != 1) {
      setshowApprovalDuration(false)
    }
  })

  useEffect(() => {
    getApplicationAttachments()
  }, [])

  const decisionValueChange = value => {
    const commentsCodes = ["011", "012"]
    if (commentsCodes.includes(value)) {
      setshowComments(true)
    } else {
      setcomments("")
      setshowComments(false)
    }

    console.log("Service ID")
    console.log(props.appDetails.service_id)

    // Only show approval duration for Auth Plastics
    if (props.appDetails.service_id != 1) {
      setshowApprovalDuration(false)
    } else {
      if (value === "010") {
        setshowApprovalDuration(true)
      } else {
        setshowApprovalDuration(false)
      }
    }

    // show certificate preview
    if (value == "010") {
      setshowCertificatePreview(true)
    } else {
      setshowCertificatePreview(false)
    }
  }

  const getApplicationAttachments = () => {
    const descriptions = ["Meeting_Minutes"]
    const atts = props.appDetails.application_attachments.filter(attachment =>
      descriptions.includes(attachment.description)
    )
    setstaffUploads(atts)
  }

  return (
    <>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <div>
                <AvField
                  type="hidden"
                  name="application_id"
                  value={props.appDetails.id}
                />
              </div>

              <div>
                {props.error && props.error == true ? (
                  <Row className="alert alert-danger">
                    <Col md="12">{props.message}</Col>
                  </Row>
                ) : null}

                {props.success && props.success == true ? (
                  <Row className="alert alert-success">
                    <Col md="8">{props.message}</Col>
                    <Col md="4">
                      <Link to="/officer-reviewed" style={{ float: "right" }}>
                        Back
                      </Link>
                    </Col>
                  </Row>
                ) : null}
              </div>

              <div className="mb-3">
                <AvField
                  //value={defaultValues.decision_code}
                  type="select"
                  name="decision_code"
                  label="Select Decision"
                  onChange={v => {
                    decisionValueChange(v.target.value)
                  }}
                  required
                  disabled={props.success}
                >
                  <option value="">--select Decision--</option>
                  <option value="010">Propose to Approve</option>

                  <option value="011">Propose to Reject</option>
                  <option value="008">Send Back</option>
                </AvField>
              </div>

              <Row className="mb-3">
                <label
                  htmlFor="txtAddress1Billing"
                  className="col-lg-3 col-form-label"
                >
                  Reason
                </label>
                <div className="col-lg-9">
                  <AvField
                    //value={defaultValues.reason}
                    type="textarea"
                    name="reason"
                    rows="2"
                    required
                    className="form-control"
                    disabled={props.success}
                  ></AvField>
                </div>
              </Row>

              {showApprovalDuration ? (
                <Row className="mb-3">
                  <div>
                    <AvField
                      type="number"
                      name="validity_days_from_approval"
                      label="Enter validity days from the date of approval (Eg. 365 days)"
                      rows="2"
                      required
                      className="form-control"
                    />
                  </div>
                </Row>
              ) : null}

              {showComments ? (
                <Row className="mb-3">
                  <label
                    htmlFor="txtAddress1Billing"
                    className="col-lg-3 col-form-label"
                  >
                    Comments to applicant
                  </label>
                  <div className="col-lg-9">
                    <AvField
                      //value={defaultValues.comment_to_applicant}
                      type="textarea"
                      name="comment_to_applicant"
                      rows="4"
                      required
                      className="form-control"
                      disabled={props.success}
                      onChange={v => {
                        setcomments(v.target.value)
                      }}
                    ></AvField>
                  </div>
                </Row>
              ) : null}

              {showCertificatePreview ? (
                <Row className="mb-3">
                  <Alert color="info">
                    Before submitting your review, please click on the preview
                    link below to see how the certificate will display after the
                    approval processes.
                  </Alert>
                  <a className="linkItem" target="_blank" href={certPreviewUrl}>
                    Preview Certificate{" "}
                    <i
                      className="fa fa-certificate"
                      title="Preview Certificate"
                    ></i>
                  </a>
                </Row>
              ) : null}

              <div>
                <hr></hr>
                <label>Documents uploaded by officer</label>
                <ViewAttachments attachments={staffUploads} />
              </div>

              {props.loading && props.loading === true ? (
                <Link
                  to="#"
                  className="spinner-border text-info"
                  style={{ float: "right" }}
                />
              ) : (
                <div className="mt-5">
                  <button
                    className="btn btn-lg btn-primary col-12"
                    disabled={props.success}
                  >
                    Submit Review
                  </button>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default HeadFormNoObjection
